import { MetadataDefinition } from '~core/models/metadata-definition.model';
import { ExportMetadataSet } from './export-metadata-set.model';

export class ExportAppMetadata {
  constructor(
    public base: MetadataDefinition[],
    public sets: ExportMetadataSet[]
  ) {}

  static adapt(item: any): ExportAppMetadata {
    return new ExportAppMetadata(
      item.base.map(MetadataDefinition.adaptClean),
      item.sets.map(ExportMetadataSet.adapt)
    );
  }
}
